
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import {
  Print,
  Visibility,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { Chip } from '@mui/material';
import { generatePdf } from "../../Accounts/GeneralVoucherPrint";

const GeneralVoucher = ({ data }) => {
  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };


  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>

      <TableContainer
        component={Paper}
        sx={{
          maxHeight: '48vh', // 👈 yaha height do
          overflow: "auto",
        }}
      >

        <Table
          stickyHeader
          size="small"
          sx={{
            minWidth: 1600, // ensure horizontal scroll appears when content overflows
            "& td, & th": {
              fontWeight: "400",
              borderBottom: "1px solid #ccc",
              textAlign: "center",
              whiteSpace: "nowrap",
              backgroundColor: "#f5f5f5",
              padding: "0px 16px",
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#f5f5f5",
                "& th": {
                  fontWeight: "bold !important",
                  color: "#333",
                  borderBottom: "1px solid #999",
                  whiteSpace: "nowrap",
                  pt: 0.5,
                  pb: 0.5
                },
              }}
            >

              <TableCell
                sx={{
                  position: "sticky",
                  backgroundColor: "#f5f5f5",
                  zIndex: 3,
                }}
              >
                S.No.
              </TableCell>

              <TableCell>Voucher No</TableCell>
              <TableCell>Total Amt</TableCell>
              <TableCell>Paid Amt</TableCell>
              <TableCell>Bal Amt</TableCell>
              <TableCell>Ladger Name</TableCell>
              <TableCell>Bill No</TableCell>
              <TableCell>Bill Date</TableCell>
              <TableCell>Project</TableCell>
              <TableCell>Division</TableCell>
              <TableCell>Created By</TableCell>

              <TableCell>Payment Status</TableCell>
              <TableCell>Approved By</TableCell>
              <TableCell>Date</TableCell>


              <TableCell>Narration</TableCell>
              <TableCell>Remarks</TableCell>
              <TableCell
                className="no-print"
                sx={{
                  position: "sticky",
                  right: 0,
                  backgroundColor: "#f5f5f5",
                  zIndex: 3,
                  width: 200,
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((voucher, index) => (

              <TableRow
                hover
                key={index}
                sx={{
                  position: "sticky",
                  right: 0,
                  backgroundColor: "#fff",
                  zIndex: 1,

                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                    "& td": {
                      backgroundColor: "#e3f2fd !important",
                    },
                  },
                  "& td": {
                    paddingTop: '2px !important',
                    paddingBottom: '2px !important',
                    fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
                    whiteSpace: "nowrap",
                    padding: "0px 16px",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "white" : "inherit",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "inherit",
                  },
                }}
              >

                <TableCell
                  sx={{
                    position: "sticky",
                    backgroundColor: "#fafafa",
                    zIndex: 3,
                  }}
                >
                  {index + 1}
                </TableCell>

                <TableCell> {voucher.gen_number}</TableCell>

                <TableCell>{Number(voucher.grandtotal || 0).toLocaleString("en-IN")}
                </TableCell>
                <TableCell>  {Number(voucher.receipt_amount || 0).toLocaleString("en-IN")}
                </TableCell>
                <TableCell> {Number(voucher.balance_amount || 0).toLocaleString("en-IN")}
                </TableCell>
                <TableCell>{voucher.imprest_name || voucher.supplier_name || voucher.advanceworker_name || voucher.Transporter_name}</TableCell>

                <TableCell>{voucher.bill_no}</TableCell>
                <TableCell>{formatDate(voucher.bill_date)}</TableCell>

                <TableCell>{voucher.project_name || ""}</TableCell>
                <TableCell>{voucher.division_name}</TableCell>
                <TableCell>{voucher.created_by_name}</TableCell>

                <TableCell>
                  <Chip
                    label={
                      voucher.payment_status === "Paid"
                        ? "Paid"
                        : voucher.payment_status === "Unpaid"
                          ? "Unpaid"
                          : "Partial"
                    }
                    color={
                      voucher.payment_status === "Paid"
                        ? "success"   // green
                        : voucher.payment_status === "Unpaid"
                          ? "error"     // red
                          : "warning"   // yellow/orange
                    }
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
                <TableCell>{voucher.approved_name}</TableCell>
                <TableCell>{formatDate(voucher.created_at)}</TableCell>


                <TableCell>
                  <Tooltip title={voucher.narration} arrow>
                    <span>{truncateText(voucher.narration, 20)}</span>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Tooltip title={voucher.remarks || ""} arrow>
                    <span>{truncateText(voucher.remarks || "", 20)}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fafafa",
                    zIndex: 2,

                  }}
                >
                  <span style={{ display: "inline-block", width: 36, textAlign: "center" }}>
                    {typeof voucher.attachment === "string" ? (
                      <a
                        href={`${voucher.attachment}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <IconButton color="info"
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small">
                          <Visibility fontSize="small" />
                        </IconButton>
                      </a>
                    ) : voucher.attachment instanceof File ? (

                      <a
                        href={URL.createObjectURL(voucher.attachment)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <IconButton color="info"
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small">
                          <Visibility fontSize="small" />
                        </IconButton>
                      </a>
                    ) : (
                      <span style={{ display: "inline-block", width: 24 }} />
                    )}
                  </span>


                  <IconButton
                    sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                    color="warning"
                    size="small" onClick={() => generatePdf(voucher)}>
                    <Print fontSize="small" />
                  </IconButton>
                </TableCell>


              </TableRow>
            ))}


          </TableBody>
        </Table>

      </TableContainer>


    </>
  );
};

export default GeneralVoucher;







